$('header#header').ready(function () {
    //dropdown sub menu in header
    let subMenus=$('ul.sub-menu');
    subMenus.each(function (index , el){
        let parent=$(this).siblings('a')
        $(el).mouseenter(function () {
            $(this).addClass('active')
        })
        $(el).mouseleave(function () {
            $(this).removeClass('active')
        })
        parent.mouseenter(function () {
            $(el).addClass('active')
        })
        parent.mouseleave(function () {
            $(el).removeClass('active')
        })
    })

    $('.header__left-search').click(function () {
        $('.search-form').toggleClass('active');
    })
})

// menu-responsive
$('body').on('click', function () {
    $('.mega-menu-site-responsive').removeClass('active');
    $(this).removeClass('overflow-none');
});

$('.mega-menu-responsive').on('click', function (e) {
    e.stopPropagation();
    $('.mega-menu-site-responsive').toggleClass('active');
    $('.mask-shadow').toggleClass('active');
    $('body').toggleClass('overflow-none');
});

$('.mega-menu-site-responsive').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parent().toggleClass('active');
    $(this).siblings('ul').slideToggle(500);
});

$('.mega-menu-site-responsive__header').on('click', function (e) {
    e.stopPropagation();
});

$('#res-menu-body').on('click', function (e) {
    e.stopPropagation();
});

$('.mega-menu-site-responsive__header .close').on('click', function () {
    $('.mega-menu-site-responsive').toggleClass('active');
    $('.mask-shadow').toggleClass('active');
    $('body').toggleClass('overflow-none');
});

$('.mask-shadow').on('click', function () {
    $('.mega-menu-site-responsive').toggleClass('active');
    $(this).toggleClass('active');
});
$('.mega-menu-site-responsive__body .has-children').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active').find('ul').slideToggle();

});

//end-menu-responsive
